<ion-grid *ngIf="dataServ.menuItem && dataServ.menuItem.form_fields">
  <ion-row>
    <ng-container *ngFor="let field of dataServ.menuItem.form_fields; let i = index">
      <ion-col class="{{field.field_type===6 ? 'column': ''}}" size="12">
        <ng-container [ngSwitch]="field.field_type">
          <ion-item lines="none" class="{{field.field_type === 6 ? '': 'bordered'}}">
            <ion-label  [position]="field.field_type === 5 ? '' : 'stacked'">{{field.field_caption | caption |
              translate}}
              <ion-text id="form-{{ i }}" *ngIf="field.is_required" color="primary">*</ion-text>
            </ion-label>
            <ion-input type="text" [(ngModel)]="field.value" *ngSwitchCase="1"></ion-input>

            <ion-textarea [(ngModel)]="field.value" *ngSwitchCase="2" rows="2"></ion-textarea>

            <ng-container *ngSwitchCase="3">
              <input type="date" [(ngModel)]="field.value">
              <ion-icon slot="end" name="calendar-outline" color="primary"></ion-icon>
            </ng-container>

            <ng-container *ngSwitchCase="4">
              <input type="datetime-local" [(ngModel)]="field.value">
              <ion-icon slot="end" name="calendar-outline" color="primary"></ion-icon>
            </ng-container>

            <ion-checkbox slot="end" [(ngModel)]="field.value" *ngSwitchCase="5"></ion-checkbox>
          </ion-item>

          <ng-container *ngSwitchCase="6">
            <!-- Burada ion-buttons kullanarak + ve - butonlarını ekleyeceğiz -->
            <div class="button-wrapper">
              <ion-buttons>
                <!-- Azaltma butonu -->
                <ion-button slot="start" equalWith="height" fill="solid" color="primary" class="ion-no-padding"
                  (click)="updateValue(field, '-')">
                  <ion-icon slot="icon-only" name="remove-outline"></ion-icon>
                </ion-button>
              </ion-buttons>

              <div class="text-area">
                <!-- Sayıyı gösteren input alanı -->
                <ion-text type="number">{{getFieldValue(field)}}</ion-text>
              </div>
              <ion-buttons>
                <!-- Artırma butonu -->
                <ion-button slot="end" equalWith="height" fill="solid" color="primary" class="ion-no-padding"
                  (click)="updateValue(field, '+')">
                  <ion-icon slot="icon-only" name="add-outline"></ion-icon>
                </ion-button>
              </ion-buttons>
            </div>
          </ng-container>

          <ng-container *ngSwitchCase="7">
            <app-alphanum-inputs [field]="field"></app-alphanum-inputs>
          </ng-container>

          <ng-container *ngSwitchCase="8">
            <app-alphanum-inputs [field]="field"></app-alphanum-inputs>
          </ng-container>
          
          <ng-container *ngSwitchCase="9">
            <app-alphanum-inputs [field]="field"></app-alphanum-inputs>
          </ng-container>

        </ng-container>
      </ion-col>
    </ng-container>
  </ion-row>
</ion-grid>